// extracted by mini-css-extract-plugin
module.exports = {"warningModal":"edit-camera_warningModal_1KLeV","textarea":"edit-camera_textarea_a_cSM"};